<template>
  <div class="card noborder">
    <div class="card-body pb-0">
      <h5 class="mb-0">Kiosk Equipment Details</h5>
      <hr>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label class="custom-label">What kind of Headunit/s</label>
        <div class="row">
          <div class="col-sm-6 col-lg-4">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="headunit-kiosk1"
                @change="$store.commit('changeKioskHeadunits', 'new')"
                :checked="kiosk.headunits.includes('new')"
              >
              <label class="form-check-label" for="headunit-kiosk1">New</label>
            </div>
            <div v-if="kiosk.headunits.includes('new')" class="mt-3">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" style="width: 150px;">G20</span>
                </div>
                <input class="form-control" placeholder="0" style="max-width: 80px;"
                  :value="kiosk.headunitsNew['G20']"
                  @input="$store.commit('changeKioskHeadunitsNew', { headunit: 'G20', value: $event.target.value })"
                >
                <div class="input-group-append">
                  <span class="input-group-text">Units</span>
                </div>
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" style="width: 150px;">Janus</span>
                </div>
                <input class="form-control" placeholder="0" style="max-width: 80px;"
                  :value="kiosk.headunitsNew['Janus']"
                  @input="$store.commit('changeKioskHeadunitsNew', { headunit: 'Janus', value: $event.target.value })"
                >
                <div class="input-group-append">
                  <span class="input-group-text">Units</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="headunit-kiosk2"
                @change="$store.commit('changeKioskHeadunits', 'refurbished')"
                :checked="kiosk.headunits.includes('refurbished')"
              >
              <label class="form-check-label" for="headunit-kiosk2">Refurbished</label>
            </div>
            <div v-if="kiosk.headunits.includes('refurbished')" class="mt-3">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" style="width: 150px;">G4XL 1 ref</span>
                </div>
                <input class="form-control" placeholder="0" style="max-width: 80px;"
                  :value="kiosk.headunitsRefurbished['G4XL 1 ref']"
                  @input="$store.commit('changeKioskHeadunitsRefurbished', { headunit: 'G4XL 1 ref', value: $event.target.value })"
                >
                <div class="input-group-append">
                  <span class="input-group-text">Units</span>
                </div>
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" style="width: 150px;">G4XL 2 ref</span>
                </div>
                <input class="form-control" placeholder="0" style="max-width: 80px;"
                  :value="kiosk.headunitsRefurbished['G4XL 2 ref']"
                  @input="$store.commit('changeKioskHeadunitsRefurbished', { headunit: 'G4XL 2 ref', value: $event.target.value })"
                >
                <div class="input-group-append">
                  <span class="input-group-text">Units</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="small-printers-kiosk">
        <div class="form-group">
          <label class="custom-label">What kind of 4' Printer/s</label>
          <div class="row">
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="small-printers-kiosk1"
                  @change="$store.commit('changeSmallPrinters', { key: 'kiosk', value:'new' })"
                  :checked="kiosk.smallPrinters.includes('new')"
                >
                <label class="form-check-label" for="small-printers-kiosk1">New</label>
              </div>
              <div v-if="kiosk.smallPrinters.includes('new')" class="mt-3">

                <custom-input-group
                  v-for="printer in Object.keys(kiosk.smallPrintersNew)"
                  :key="printer"
                  :prependLabel="printer"
                  appendLabel="Printers"
                  :value="kiosk.smallPrintersNew[printer]"
                  @input="$store.commit('changeSmallPrintersNew', { key:'kiosk', printer, value: $event })"
                />

              </div>
            </div>
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="small-printers-kiosk2"
                  @change="$store.commit('changeSmallPrinters', { key: 'kiosk', value:'refurbished' })"
                  :checked="kiosk.smallPrinters.includes('refurbished')"
                >
                <label class="form-check-label" for="small-printers-kiosk2">Refurbished</label>
              </div>
              <div v-if="kiosk.smallPrinters.includes('refurbished')" class="mt-3">

                <custom-input-group
                  v-for="printer in Object.keys(kiosk.smallPrintersRefurbished)"
                  :key="printer"
                  :prependLabel="printer"
                  appendLabel="Printers"
                  :value="kiosk.smallPrintersRefurbished[printer]"
                  @input="$store.commit('changeSmallPrintersRefurbished', { key:'kiosk', printer, value: $event })"
                />

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="large-printers-kiosk">
        <div class="form-group">
          <label class="custom-label">What kind of 8' Printer/s</label>
          <div class="row">
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="large-printers-kiosk1"
                  @change="$store.commit('changeLargePrinters', { key: 'kiosk', value:'new' })"
                  :checked="kiosk.largePrinters.includes('new')"
                >
                <label class="form-check-label" for="large-printers-kiosk1">New</label>
              </div>
              <div v-if="kiosk.largePrinters.includes('new')" class="mt-3">

                <custom-input-group
                  v-for="printer in Object.keys(kiosk.largePrintersNew)"
                  :key="printer"
                  :prependLabel="printer"
                  appendLabel="Printers"
                  :value="kiosk.largePrintersNew[printer]"
                  @input="$store.commit('changeLargePrintersNew', { key:'kiosk', printer, value: $event })"
                />

              </div>
            </div>
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="large-printers-kiosk2"
                  @change="$store.commit('changeLargePrinters', { key: 'kiosk', value:'refurbished' })"
                  :checked="kiosk.largePrinters.includes('refurbished')"
                >
                <label class="form-check-label" for="large-printers-kiosk2">Refurbished</label>
              </div>
              <div v-if="kiosk.largePrinters.includes('refurbished')" class="mt-3">

                <custom-input-group
                  v-for="printer in Object.keys(kiosk.largePrintersRefurbished)"
                  :key="printer"
                  :prependLabel="printer"
                  appendLabel="Printers"
                  :value="kiosk.largePrintersRefurbished[printer]"
                  @input="$store.commit('changeLargePrintersRefurbished', { key:'kiosk', printer, value: $event })"
                />

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cabinet">
        <div class="form-group">
          <label class="custom-label">What kind of Cabinet/s</label>
          <br>
          <div class="row">
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="cabinets-kiosk1"
                  @change="$store.commit('changeKioskCabinets', 'new')"
                  :checked="kiosk.cabinets.includes('new')"
                >
                <label class="form-check-label" for="cabinets-kiosk1">New</label>
              </div>
              <div class="mt-3" v-if="kiosk.cabinets.includes('new')">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 155px;">Skipper 17'</span>
                  </div>
                  <input class="form-control" placeholder="0" style="max-width: 80px;"
                    :value="kiosk.cabinetsNew['Skipper 17']"
                    @input="$store.commit('changeKioskCabinetsNew', { cabinet: 'Skipper 17', value: $event.target.value })"
                  >
                  <div class="input-group-append">
                    <span class="input-group-text">Cabinets</span>
                  </div>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 155px;">Skipper 24'</span>
                  </div>
                  <input class="form-control" placeholder="0" style="max-width: 80px;"
                    :value="kiosk.cabinetsNew['Skipper 24']"
                    @input="$store.commit('changeKioskCabinetsNew', { cabinet: 'Skipper 24', value: $event.target.value })"
                  >
                  <div class="input-group-append">
                    <span class="input-group-text">Cabinets</span>
                  </div>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 155px;">Transformer 24'</span>
                  </div>
                  <input class="form-control" placeholder="0" style="max-width: 80px;"
                    :value="kiosk.cabinetsNew['Transformer 24']"
                    @input="$store.commit('changeKioskCabinetsNew', { cabinet: 'Transformer 24', value: $event.target.value })"
                  >
                  <div class="input-group-append">
                    <span class="input-group-text">Cabinets</span>
                  </div>
                </div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 155px;">6900 Cabinet 17'</span>
                  </div>
                  <input class="form-control" placeholder="0" style="max-width: 80px;"
                    :value="kiosk.cabinetsNew['6900 Cabinet 17']"
                    @input="$store.commit('changeKioskCabinetsNew', { cabinet: '6900 Cabinet 17', value: $event.target.value })"
                  >
                  <div class="input-group-append">
                    <span class="input-group-text">Cabinets</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="cabinets-kiosk2"
                  @change="$store.commit('changeKioskCabinets', 'refurbished')"
                  :checked="kiosk.cabinets.includes('refurbished')"
                >
                <label class="form-check-label" for="cabinets-kiosk2">Refurbished</label>
              </div>
              <div class="mt-3" v-if="kiosk.cabinets.includes('refurbished')">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 175px;">Transformer ref 17'</span>
                  </div>
                  <input class="form-control" placeholder="0" style="max-width: 80px;"
                    :value="kiosk.cabinetsRefurbished['Transformer ref 17']"
                    @input="$store.commit('changeKioskCabinetsRefurbished', { cabinet: 'Transformer ref 17', value: $event.target.value })"
                  >
                  <div class="input-group-append">
                    <span class="input-group-text">Cabinets</span>
                  </div>
                </div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 175px;">Transformer ref 24'</span>
                  </div>
                  <input class="form-control" placeholder="0" style="max-width: 80px;"
                    :value="kiosk.cabinetsRefurbished['Transformer ref 24']"
                    @input="$store.commit('changeKioskCabinetsRefurbished', { cabinet: 'Transformer ref 24', value: $event.target.value })"
                  >
                  <div class="input-group-append">
                    <span class="input-group-text">Cabinets</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['kiosk'],
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/KioskForm.vue